<template>
	<div class="cost-expenses-container">
		<div class="tab-header">
			<button class="tab-btn" :class="{ active: activeTab === 'totalCost' }"
				@click="activeTab = 'totalCost'">总成本费用</button>
			<button class="tab-btn" :class="{ active: activeTab === 'rawMaterials' }"
				@click="activeTab = 'rawMaterials'">原辅材料</button>
			<button class="tab-btn" :class="{ active: activeTab === 'fuelPower' }"
				@click="activeTab = 'fuelPower'">燃料动力</button>
			<button class="tab-btn" :class="{ active: activeTab === 'welfare' }"
				@click="activeTab = 'welfare'">工资福利</button>
			<button class="tab-btn" :class="{ active: activeTab === 'depreciation' }"
				@click="activeTab = 'depreciation'">折旧</button>
			<button class="tab-btn" :class="{ active: activeTab === 'amortization' }"
				@click="activeTab = 'amortization'">摊销</button>
		</div>

		<div class="tab-content">
			<TotalCost v-if="activeTab === 'totalCost'" ref="totalCostRef" @save="handleSave" />
			<RawMaterials v-if="activeTab === 'rawMaterials'" ref="rawMaterialsRef" @save="handleSave" />
			<FuelPower v-if="activeTab === 'fuelPower'" ref="fuelPowerRef" @save="handleSave" />
			<Welfare v-if="activeTab === 'welfare'" ref="welfareRef" @save="handleSave" />
			<Depreciation v-if="activeTab === 'depreciation'" ref="depreciationRef" @save="handleSave" />
			<Amortization v-if="activeTab === 'amortization'" ref="amortizationRef" @save="handleSave" />
		</div>
	</div>
</template>

<script>
	import TotalCost from './TotalCost.vue'
	import RawMaterials from './RawMaterials.vue'
	import FuelPower from './FuelPower.vue'
	import Welfare from './Welfare.vue'
	import Depreciation from './Depreciation.vue'
	import Amortization from './Amortization.vue'
	import { totalCost, workingCapital } from '@/utils/comp.js'

	export default {
		name: 'CostExpenses',
		components: {
			TotalCost,
			RawMaterials,
			FuelPower,
			Welfare,
			Depreciation,
			Amortization
		},
		data() {
			return {
				activeTab: 'totalCost'
			}
		},
		methods: {
			handleSave() {
				this.saveToVuex()
				this.$toast.success('保存成功')
			},
			saveToVuex() {
				const projectData = { ...this.$store.state.projectData } || {}

				const totalCostData = this.$refs.totalCostRef?.getFormData() || {}
				const rawMaterialsData = this.$refs.rawMaterialsRef?.getFormData() || {}
				const fuelPowerData = this.$refs.fuelPowerRef?.getFormData() || {}
				const welfareData = this.$refs.welfareRef?.getFormData() || {}
				const depreciationData = this.$refs.depreciationRef?.getFormData() || {}
				const amortizationData = this.$refs.amortizationRef?.getFormData() || {}

				const investmentEstimate = {
					...projectData.investmentEstimate,
					totalCostData,
					rawMaterialsData,
					fuelPowerData,
					welfareData,
					depreciationData,
					amortizationData
				}

				projectData.investmentEstimate = investmentEstimate

				this.$store.commit('setProjectData', projectData)
				this.$store.commit('setIsProjectSaved', false)

				// 调用计算函数
				this.$nextTick(() => {
					totalCost()
					workingCapital()
				})
			}
		}
	}
</script>

<style scoped>
	.cost-expenses-container {
		width: 100%;
		height: 100%;
		display: flex;
		flex-direction: column;
	}

	.tab-header {
		display: flex;
		gap: 0;
		margin-bottom: 20px;
		border-bottom: 2px solid #409eff;
	}

	.tab-btn {
		padding: 10px 24px;
		border: none;
		background-color: #f5f7fa;
		color: #606266;
		font-size: 12px;
		cursor: pointer;
		transition: all 0.3s;
		border-radius: 4px 4px 0 0;
		margin-right: 2px;
	}

	.tab-btn:hover {
		color: #409eff;
		background-color: #ecf5ff;
	}

	.tab-btn.active {
		background-color: #409eff;
		color: #fff;
	}

	.tab-content {
		flex: 1;
		overflow: auto;
	}
</style>
